<template lang="pug">
#upload-arquivo-territorio-gleba-operacao
    .upload-container
        .upload-content(v-if='showInputUpload')
            label Upload de arquivo KML, KMZ, WKT ou Shapefile
            el-upload(
                drag,
                :file-list='files',
                action='alert',
                :auto-upload='false',
                :on-change='onChange',
                :on-exceed='onExceed',
                :limit='1',
                ref='upload'
            )
                i.el-icon-upload(style='margin-top: 40px')
                .el-upload__text Arraste o arquivo aqui ou <em>clique para subir</em>

        BaseButton.upload__button(
            title='Upload de arquivo',
            icon='el-icon-upload',
            @click='showInputUpload = !showInputUpload'
        )
</template>

<script>
import geoJsonConverter from '@/utils/conversorGeojson';
import EventBus from '@/utils/eventBus';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'UploadArquivoTerritorioGlebaOperacao',

    components: {
        BaseButton
    },

    props: {
        mapa: {
            type: Object,
            required: true
        },
        callback: {
            type: Function,
            required: true
        }
    },

    data() {
        return {
            geometry: null,
            files: [],
            showInputUpload: null
        };
    },

    created() {
        EventBus.$off('upload-gleba:fechar-componente');
        EventBus.$on('upload-gleba:fechar-componente', this.closeInputUpload);
    },

    methods: {
        onExceed() {
            this.$notify.warning({
                message: 'Só é permitido o upload de um arquivo por vez.',
                position: 'top-left'
            });
        },

        onChange(file) {
            let reader = new FileReader();
            let extension = file.name.split('.').pop().toLowerCase();
            reader.onload = async e => {
                await geoJsonConverter
                    .parse(extension, e.target.result, file.raw)
                    .then(geoJson => {
                        if (geoJson && geoJson.features) {
                            this.callback(geoJson);
                            this.$refs.upload.clearFiles();
                        } else {
                            this.$refs.upload.clearFiles();
                            this.$notify.warning({
                                message: 'Arquivo inválido.',
                                position: 'top-left'
                            });
                        }
                    })
                    .catch(rejectReason => {
                        this.$notify.error({ message: rejectReason });
                    });
            };
            reader.readAsText(file.raw);
        },

        closeInputUpload() {
            this.showInputUpload = false;
        }
    }
};
</script>

<style lang="scss">
#upload-arquivo-territorio-gleba-operacao {
    .upload-container {
        display: flex;
    }

    .upload-content {
        background-color: var(--white);
        position: absolute;
        width: 400px;
        padding: 1rem;
        border-radius: 10px;
        top: 0;
        right: 50px;
    }

    .upload__button {
        width: 31px !important;
        height: 31px !important;
        min-width: 31px !important;
        color: var(--black);
        padding: 0 !important;

        i {
            color: #404040;
        }
    }

    .el-upload-list__item-name {
        width: 100% !important;
    }

    .el-upload-dragger {
        height: 150px !important;
    }
}
</style>
